import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bls_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve an image url that may be relative (/api/media/..) or absolute
export const imgUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

// ---- Analytics tracking ----
function sessionId() {
  let s = localStorage.getItem("bls_session");
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("bls_session", s);
  }
  return s;
}

export const track = (type, path = window.location.pathname) => {
  api.post("/track", { type, path, session_id: sessionId() }).catch(() => {});
};

export default api;
